import { render } from "./EnrollmentEdit.vue?vue&type=template&id=c90e7e98&scoped=true"
import script from "./EnrollmentEdit.vue?vue&type=script&lang=js"
export * from "./EnrollmentEdit.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-c90e7e98"

export default script